import { GameStatus } from '@adgf/shared';
import type { GameManifest } from '@adgf/shared';

/**
 * Game Manifest for "30 Second Reaction".
 *
 * This is the single source of truth for the game's metadata. The
 * Dynamic Game Loader reads this manifest to decide which runtime to
 * load and how to configure the session / analytics.
 *
 * Status is DRAFT by default. The local Game Registry may promote it
 * to PUBLISHED for M1 testing.
 */
const manifest: GameManifest = {
  id: '22222222-2222-2222-2222-222222222222',
  slug: '30-second-reaction',
  title: '30 Second Reaction',
  description:
    'Click targets as fast as you can in 30 seconds. Difficulty increases over time.',
  version: '0.1.0',
  template_id: null,
  runtime: 'phaser',
  status: GameStatus.DRAFT,
  difficulty: 'easy',
  duration: 30,
  features: ['touch-support', 'mouse-support', 'retry', 'difficulty-ramp'],
  entrypoint: '@adgf/game-30-second-reaction',
  analytics_schema: {
    target_spawn: 'number',
    target_click: 'number',
    wrong_click: 'number',
  },
};

export default manifest;
